import React, { useEffect, useState } from "react";
import { TMenu, TPrivilege, TUser } from "../types/config";
import { eResultCode } from "../utils/enum";
import AuthUtil from "../utils/auth";
import Utils from "../utils";
import useFetch from "../hooks/useFetch";
import {
  GetChunkAPICountDtl,
  GetMenuHierarchyList,
  GetSpecificUserData,
  // GetSpecificUserMasterData,
} from "../utils/api.constant";
import { StoreUtil } from "../utils/store";
import { SESSION_ISUSERLOOGED_KEY } from "../utils/constants";
import aesEncryptDecrypt from "../utils/aes.encrypt.decrypt";

type TProps = {
  children: React.ReactNode;
};

type TState = {
  value: {
    onUpdate: Function | undefined;
    isUserLogged: boolean;
  };
};

const UserContext = React.createContext<{
  onUpdate?: Function;
  user?: TUser;
  userName?: string;
  email?: string;
  orgid?: string;
  isUserLogged?: Boolean;
  privilegeList?: Array<TPrivilege>;
  isTempPassword?: Boolean;
  defLanguageUniqueId?: string;
  menuHierarchy?: Array<TMenu>;
  chunkSize?: number;
  apiCount?: number;
}>({});

export default function UserProvider(props: TProps) {
  const { post } = useFetch();

  // Function to update the user context state
  const onUpdate = (detail: any = {}) => {
    setState((prevState: any) => ({
      value: {
        ...prevState.value,
        ...detail,
        isUserLogged: !Utils.isNullOrUndefined(detail.id ?? prevState.value.id),
      },
    }));
  };


  useEffect(() => {

    init();
  }, []);

  const [state, setState] = useState<TState>({
    value: {
      onUpdate: onUpdate,
      isUserLogged: false,
    },
  });

  // Initialization function called on component mount
  async function init() {

    if (
      AuthUtil.isTokenExist()
    ) {
      const user: TUser = await initializeUser();
      onUpdate({
        user: user,
      });
    }
  }


  // Function to fetch user information from the server
  const initializeUser = async () => {
    try {
      const requestPayload = {
        data: {},
      };
      const response = await post(GetSpecificUserData, requestPayload);
      const { data, dataResponse } = response;
      const { returnCode, description } = dataResponse;
      if (returnCode === eResultCode.SUCCESS) {
        const value = data;
        return value;
      } else {
        AuthUtil.logout();
        console.error(`Error while initializing user: ${description}`);
      }
    } catch (error) {
      AuthUtil.logout();
      console.error(error);
    }
  };


  // Render the UserContext.Provider with the context value and children
  return (
    <UserContext.Provider value={state.value}>
      {props.children}
    </UserContext.Provider>
  );
}

// Export the UserContext and UserProvider for use in other components
export { UserContext, UserProvider };
